import type { FormlyFieldConfig } from '@ngx-formly/core';

import type { TranslationLanguage } from '../../types/translation.types';

export const LOCALE_KEY_SUFFIX: Record<TranslationLanguage, string> = {
  nl: '',
  en: 'En',
  de: 'De',
  fr: 'Fr',
  pt: 'Pt',
};

const ALL_LOCALE_KEY_SUFFIXES = Object.values(LOCALE_KEY_SUFFIX);

/**
 * True when an HTML string contains no visible text. Strips tags and
 * `&nbsp;` so CKEditor placeholders like `<p></p>`, `<p>&nbsp;</p>`,
 * `<p><br></p>` all collapse to empty.
 */
export function isHtmlEmpty(value: string | null | undefined): boolean {
  if (!value) return true;
  return value.replace(/<[^>]+>|&nbsp;/gi, '').trim().length === 0;
}

/**
 * Formly validator expression for translatable fields. Valid when at
 * least one configured locale slot has non-empty content, or when
 * `props.requireOneLocale` isn't set. Reads `field.model` rather than
 * `control.value` because the EN/DE/FR/PT slots aren't bound to this
 * field's `FormControl` — only the source (NL) slot is.
 */
export function atLeastOneLocaleExpression(
  _control: unknown,
  field: FormlyFieldConfig,
): boolean {
  if (!field.props?.['requireOneLocale']) return true;
  const model = (field.model ?? {}) as Record<string, unknown>;
  const baseName = (field.props['fieldBaseName'] as string) || '';
  return ALL_LOCALE_KEY_SUFFIXES.some(
    (suffix) => !isHtmlEmpty(model[baseName + suffix] as string | null | undefined),
  );
}
